import React, { useState, useEffect } from 'react'
import { Button, Card, Form, Modal, Row, Col } from 'react-bootstrap'
import { Link, useParams, useNavigate } from 'react-router-dom'
import Swal from 'sweetalert2'

import Layout from '../../layout/default'
import Block from '../../components/Block/Block'
import DataTable from '../../components/DataTable/DataTable'
import { Icon } from '../../components'
import { userColumns } from "../../store/countries/CountriesData"
import instance from "../api"

function CountriesList() {
    const { country_id } = useParams()
    // NEW CODE
    const [ searchText, setSearchText ] = useState("")
    // END NEW CODE
    
    const [showModal, setShowModal] = useState(false)
    const [countriesData, setCountriesData] = useState([])
    const [countryName, setCountryName] = useState('')
    const [isoCode2, setIsoCode2] = useState('')
    const [isoCode3, setIsoCode3] = useState('')
    const [postcodeRequired, setPostcodeRequired] = useState(0)
    const [editingCountry, setEditingCountry] = useState(null)
    const [page, setPage] = useState(0)
    const [rowsPerPage, setRowsPerPage] = useState(10)
    const [totalCount, setTotalCount] = useState(0)

    const [fieldErrors, setFieldErrors] = useState({
        countryName: false,
        // isoCode2: false,
        // isoCode3: false,
        // postcodeRequired: false,
    })

    const navigate = useNavigate()

    const handleShowModal = () => setShowModal(true)

    const handleCloseModal = () => {
        setShowModal(false)
        navigate('/countries-manage/countries-list')
        resetForm()
    }

    const resetForm = () => {
        setCountryName('')
        setIsoCode2('')
        setIsoCode3('')
        setPostcodeRequired(0)
        setEditingCountry(null)
        setFieldErrors({
            countryName: false,
            isoCode2: false,
            isoCode3: false,
            postcodeRequired: false,
        })
    }

    const validateForm = () => {
        const errors = {}

        if (!countryName) errors.countryName = true
        // if (!isoCode2) errors.isoCode2 = true;
        // if (!isoCode3) errors.isoCode3 = true;
        // if (!postcodeRequired) errors.postcodeRequired = true;

        setFieldErrors(errors)

        return Object.values(errors).every(error => !error)
    }

    const countryColumns = userColumns({ setCountriesData })

    const fetchData = async (page, pageSize) => {
        try {
            const queryParams = `pageSize=${pageSize}&page=${page}` + 
                      (searchText ? `&search=${searchText}` : '');
            const response = await instance.get(
                // `api/Master/Country?pageSize=${pageSize}&page=${page}`
                `api/Master/Country?${queryParams}`
            )
            setCountriesData(response.data.rows)
            setTotalCount(response.data.count)

        } catch (error) {
            console.error('Error fetching data:', error)
        }
    }

    const fetchCountryDetails = async () => {
        try {
            const response = await instance.get(`api/Master/Country/${country_id}`, {
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json; charset=utf-8',
                    'ngrok-skip-browser-warning': 'true',
                }
            })
            const country = response.data
            setCountryName(country.name || '')
            setIsoCode2(country.iso_code_2 || '')
            setIsoCode3(country.iso_code_3 || '')
            setPostcodeRequired(country.postcode_required || 0)
            setEditingCountry(country)
            handleShowModal()
        } catch (error) {
            console.error('Error fetching Country details:', error)
        }
    }

    const postData = async () => {
        if (!validateForm()) return

        try {
            const payload = {
                name: countryName,
                iso_code_2: isoCode2,
                iso_code_3: isoCode3,
                postcode_required: postcodeRequired,
            }

            let response
            if (editingCountry) {
                response = await instance.put(`api/Master/Country/update/${editingCountry.country_id}`, payload)
            } else {
                response = await instance.post('api/Master/Country/create', payload)
            }

            // console.log('Country response:', response.data)
            handleCloseModal()
            fetchData()
            Swal.fire('Success', 'Country updated successfully!', 'success')
        } catch (error) {
            console.error('Error:', error)
            Swal.fire('Error', 'Failed to update Country!', 'error')
        }
    }

    useEffect(() => {
        fetchData(page, rowsPerPage)
        if (country_id) {
            fetchCountryDetails()
        }
    }, [ country_id, page, rowsPerPage, searchText ])
    

      // NEW CODE
    const handleSearchTextChange = (text) => {
    setSearchText(text);
    };
// NEW CODE ENDS

    const handleChangePage = (_event, newPage) => {
        setPage(newPage)
    }

    const handleChangeRowsPerPage = (event) => {
        const newSize = parseInt(event.target.value, 10)
        setRowsPerPage(newSize)
        setPage(0)
    }



    return (
        <Layout title="Countries List" content="container">
            <Block.Head>
                <Block.HeadBetween>
                    <Block.HeadContent>
                        <Block.Title tag="h2">Countries List</Block.Title>
                        {/* <nav>
                            <ol className="breadcrumb breadcrumb-arrow mb-0">
                                <li className="breadcrumb-item"><Link to="/home-ecommerce">Home</Link></li>
                                <li className="breadcrumb-item"><Link to="">Countries Manage</Link></li>
                                <li className="breadcrumb-item active" aria-current="page">Countries</li>
                            </ol>
                        </nav> */}
                    </Block.HeadContent>
                    <Block.HeadContent>
                        <ul className="d-flex">
                            <li>
                                <Button className="d-md-none" size="md" variant="primary" onClick={handleShowModal}>
                                    <Icon name="plus" />
                                    <span>Add</span>
                                </Button>
                            </li>
                            <li>
                                <Button className="d-none d-md-inline-flex" variant="primary" onClick={handleShowModal}>
                                    <Icon name="plus" />
                                    <span>Add Country</span>
                                </Button>
                            </li>
                        </ul>
                    </Block.HeadContent>
                </Block.HeadBetween>
            </Block.Head>

            <Block>
                <Card>
                    <DataTable tableClassName="data-table-head-light table-responsive" data={countriesData} columns={countryColumns} searchList={[ 'name' ]}
                        searchTerm="Country Name"

                        totalCount={totalCount}
                        page={page}
                        rowsPerPage={rowsPerPage}
                        onChangePage={handleChangePage}
                        onChangeRowsPerPage={handleChangeRowsPerPage}
                         // NEW ONE 
            onSearchTextChange={handleSearchTextChange}
            // NEW ONE ENDS
                    />
                </Card>
            </Block>

            <Modal show={showModal} onHide={handleCloseModal}>
                <Modal.Header closeButton>
                    <Modal.Title>{editingCountry ? 'Edit Country' : 'Add Country'}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form action="#">
                        <Row className="g-3">
                            <Col lg="6">
                                <Form.Group className="form-group">
                                    <Form.Label htmlFor="countryName">Country Name</Form.Label>
                                    <Form.Control
                                        id="countryName"
                                        type="text"
                                        placeholder="Name"
                                        value={countryName}
                                        required
                                        onChange={e => setCountryName(e.target.value)}
                                        className={fieldErrors.countryName ? 'is-invalid' : ''}
                                    />
                                    {fieldErrors.countryName && <div className="invalid-feedback">Please enter a country name.</div>}
                                </Form.Group>
                            </Col>
                            <Col lg="6">
                                <Form.Group className="form-group">
                                    <Form.Label htmlFor="isoCode2">ISO Code 2</Form.Label>
                                    <Form.Control
                                        id="isoCode2"
                                        type="text"
                                        placeholder="ISO Code 2"
                                        value={isoCode2}
                                        required
                                        onChange={e => setIsoCode2(e.target.value)}
                                        className={fieldErrors.isoCode2 ? 'is-invalid' : ''}
                                    />
                                    {/* {fieldErrors.isoCode2 && <div className="invalid-feedback">Please enter ISO Code 2.</div>} */}
                                </Form.Group>
                            </Col>
                            <Col lg="6">
                                <Form.Group className="form-group">
                                    <Form.Label htmlFor="isoCode3">ISO Code 3</Form.Label>
                                    <Form.Control
                                        id="isoCode3"
                                        type="text"
                                        placeholder="ISO Code 3"
                                        value={isoCode3}
                                        required
                                        onChange={e => setIsoCode3(e.target.value)}
                                        className={fieldErrors.isoCode3 ? 'is-invalid' : ''}
                                    />
                                    {/* {fieldErrors.isoCode3 && <div className="invalid-feedback">Please enter ISO Code 3.</div>} */}
                                </Form.Group>
                            </Col>
                            <Col lg="6">
                                <Form.Group className="form-group">
                                    <Form.Label htmlFor="postcodeRequired">Postcode Required</Form.Label>
                                    <Form.Control
                                        id="postcodeRequired"
                                        type="number"
                                        placeholder="Postcode Required"
                                        value={postcodeRequired}
                                        required
                                        onChange={e => setPostcodeRequired(e.target.value)}
                                        className={fieldErrors.postcodeRequired ? 'is-invalid' : ''}
                                    />
                                    {/* {fieldErrors.postcodeRequired && <div className="invalid-feedback">Please enter postcode required.</div>} */}
                                </Form.Group>
                            </Col>


                            <Col lg="12">
                                <div className="d-flex gap g-2">
                                    <div className="gap-col">
                                        <Button variant="primary" onClick={postData}>
                                            {editingCountry ? 'Update Country' : 'Add Country'}
                                        </Button>
                                    </div>
                                    <div className="gap-col">
                                        <button type="button" className="border-0 btn" onClick={handleCloseModal}>Cancel</button>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Form>
                </Modal.Body>
            </Modal>
        </Layout>
    )
}

export const handleDeleteCountry = async (country_id, setCountriesData) => {
    const confirmed = window.confirm('Are you sure you want to delete this Country?')
    if (confirmed) {
        try {
            await instance.delete(`api/Master/Country/delete/${country_id}`, {
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json; charset=utf-8',
                    'ngrok-skip-browser-warning': 'true',
                }
            })
            // console.log(`Country with ID ${country_id} deleted successfully.`)
            Swal.fire("Success", "Country deleted successfully!", "success")

            const updatedResponse = await instance.get('api/Master/Country?pageSize=100000', {
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json; charset=utf-8',
                    'ngrok-skip-browser-warning': 'true',
                }
            })
            setCountriesData(updatedResponse.data.rows)
        } catch (error) {
            console.error(`Error deleting country with ID ${country_id}:`, error)
            Swal.fire("Error", "Failed to delete Country!", "error")


            console.error(error.response)
            console.error(error.message)
        }
    }
}
export default CountriesList;


